exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-container {\n  position: absolute; }\n  .login-container .card .card-header {\n    width: 80px;\n    height: 80px;\n    margin: 0 auto;\n    margin-top: -40px;\n    border-radius: 50%;\n    font-size: 36px; }\n  .captcha {\n  background: #ffffff;\n  padding-left: 11%;\n  padding-top: 3px;\n  padding-bottom: 1px; }\n  .logo {\n  font-size: 26px;\n  text-transform: uppercase;\n  font-weight: 700; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/src/app/pages/login/login.component.scss
// module id = ../../../../../src/app/pages/login/login.component.scss
// module chunks = login.module